import React, { memo } from 'react'
import Highlighter from 'react-highlight-words'

const HighlighterWrapper = memo(({ searchWords, textToHighlight }) => (
  <Highlighter
    highlightStyle={{
      backgroundColor: '#ffc069',
      padding: 0,
    }}
    searchWords={searchWords}
    autoEscape
    textToHighlight={textToHighlight}
  />
))

export default HighlighterWrapper
